import React, { Component } from 'react';
import Button from '../Part_Sample/Button';
import Top_Bar from '../Part_Sample/Top_Bar';
import Scene_Cell from './Scene_Cell';

export default class Scenes extends Component {
	constructor(props) {
		super(props);

		this.state = {
		}

		this.scenes = this.props.param.scenes;
	}

	handleExecuteScene = (scene_id) => {
		this.props.receiver.executeScene(scene_id);
	}

	rcvExecuteScene = (response) => {
		if (response.result == 'OK') {
			window.app.showToast(this.props.receiver.getString('scene_success'), 3000);
		} else {
			window.app.showToast(this.props.receiver.getString('scene_fail'), 3000);
		}
	}

	render() {
		let style = {
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let scenes = this.scenes;
		if (this.props.receiver.active_controller.user_class != 'Admin') { //If user class is not Admin
			let temp_scenes = {};
			let accessible_points = this.props.receiver.active_controller.auth.points;
			for (let key in scenes) {
				for (let mp in scenes[key].action) {
					if (accessible_points.hasOwnProperty(mp)) { //If user has access to at least 1 mp
						temp_scenes[key] = scenes[key];
					}
				}
			}

			scenes = temp_scenes;
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('scene')}
					/>
					<div style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', width: this.props.width - 10 }}>
						<div style={{ display: Object.keys(scenes).length < 1 ? 'block' : 'none', width: '95%', paddingLeft: '10px' }}>
						<span className='title'>{this.props.receiver.getString('no_scene')}</span>
					</div>
						<div id="scenes" style={{ display: Object.keys(scenes).length < 1 ? 'none' : 'block', height: this.props.height - 123, overflow: 'auto' }}>
							{Object.keys(scenes).map((scene_id) => {
								let scene = scenes[scene_id];
								return (
									<Scene_Cell
										id={scene_id}
										receiver={this.props.receiver}
										scene={scene}
									/>
								)
							})}
							<div> &nbsp;&nbsp;&nbsp;</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}